import script from "./DomainDiscountsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainDiscountsForm.vue?vue&type=script&setup=true&lang=js"

import "./DomainDiscountsForm.vue?vue&type=style&index=0&id=4a941115&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a941115"]])

export default __exports__